export default __webpack_public_path__ + "static/media/goods_page_visual.cd69db97.png";